SearchResultsCtrl.$inject = ['$rootScope', '$scope', '$element', 'previousState', 'customerModelService', '$log', 'SettingsConstants', '$state', 'VehicleService', '$q', 'VALIDATION', 'LoaderService', '$timeout', 'dealerModelService', 'maintenanceModelService', '$anchorScroll', 'errors', 'errorScreenService', 'errorRouterService', 'sdAnalyticsService'];

function SearchResultsCtrl($rootScope, $scope, $element, previousState, customerModelService, $log, SettingsConstants, $state, VehicleService, $q, VALIDATION, loaderService, $timeout, dealerModelService, maintenanceModelService, $anchorScroll, ERR, errorScreenService, errorRouterService, sdAnalyticsService) {
    $scope.alphaNumericValidation = VALIDATION.ALPHA_NUMBERIC;
    $scope.searchMaxLen = VALIDATION.SEARCH_MAX_LENGTH;
    //stores current verifying customer to define where the verification
    //pannel be shown
    var verifyingCustomer = undefined;
    // on this page customer goes through 2 stages
    // I - customer searches himself
    // II - customer verifyes himself

    $scope.stages = {
        '0': {
            verificationPanel: {
                visible: false,
            }
        },
        '1': {
            verificationPanel: {
                visible: true,
            }
        }
    };

    $scope.searchErrorOptions = {
        template: 'template/errorscreens/search-error',
        errorType: ERR.SEARCH_ERROR,
        onErrorContinueAsNewCustomer: onErrorContinueAsNewCustomer
    };
    //get verification panel properties according to current stage
    $scope.showVerificationPanel = function (customer) {
        return $scope.selectedCustomer == customer;
    };
    //get button envoking method according to current panel and stage
    $scope.executeMethod = function (stages, stage, panel) {
        stages[stage][panel].buttonExecute.call(this);
    };
    //customer use case number - 0 by default
    $scope.currentStage = 0;
    //current search parameter
    $scope.searchString = customerModelService.getSearchParameter();
    //customer vehicles
    $scope.vehicles = [];
    //current verifivation field name
    $scope.verificationFieldName;
    //current verification field
    $scope.verificationFailed = false;
    //current customer
    $scope.customer = undefined;
    //flag of the result of the verification
    $scope.verificationFailed = false;

    $scope.searchResultLoader = loaderService.getOrCreate("searchResult");
    $scope.verificationLoader = loaderService.getOrCreate("verificationLoader");

    if ($rootScope.welcomeSearchAnimation) {
        $rootScope.welcomeSearchAnimation = false;

        var elm = $element[0].querySelector('#searchInputSegment');
        var currentInputOffset = offset(elm);
        var welcomeInputOffset = $rootScope.welcomeInputOffset;
        $scope.inputTopOffset = welcomeInputOffset.top - currentInputOffset.top - elm.offsetHeight;

        $scope.searchAnimation = false;
        $timeout(function () {
            $scope.searchAnimation = true;
        }, 300);
    } else {
        $scope.searchAnimation = true;
    }

    function init() {
        $scope.searchResultLoader.addPromise(customerModelService.resolveDealerMainManufacturer());
    }

    //search customer
    $scope.searchCustomer = function (searchString) {
        if ($scope.searchForm.$valid) {
            $scope.currentStage = 0;
            $scope.verificationFailed = false;

            resolveCustomer(searchString);
        }
    };

    //go to previous page
    $scope.goBack = function () {
        $state.go(previousState.name || SettingsConstants.APP_DEFAULT_STATE, previousState.params || {});
    };

    //show verification control means go to verification stage of
    //current form
    $scope.openVerificationPanel = function (vehicle, customer, index) {
        //customerModelService.setExistingAppointments(customer.appointments);
        //customerModelService.setCustomer(customer);
        $scope.selectedVehicle = vehicle;
        if (vehicle && _.isFunction(vehicle.getAppointment)) {
            proceedVerification();
        } else {
            $scope.searchResultLoader.addPromise(
                dealerModelService.checkAvailableTime().then(function (hasSlot) {
                    if (hasSlot) {
                        proceedVerification();
                    } else {
                        $scope.showNoTimeSlot = !hasSlot;
                        $scope.closeVerificationPanel();
                    }
                })
                    .catch(function (err) {
                        $log.error('Something went wrong due to get available time segment', err)
                    }));
        }

        function proceedVerification() {
             //Avoid 2nd step verification            
            customer.existingCustomer = true;
            customerModelService.setCustomer(customer, true);
            proceedVehicle(vehicle);
        }
    };


    //getVerificationField
    //
    //@param {object} customer
    //
    //@description
    //get the message to the customer what field he should use to
    //verify himself
    function getVerificationField(customer) {
        switch (customer.foundType) {
            case 'byPhone':
                if (customer.phone && customer.email) {
                    return {field: 'byEmail', description: 'E-mail address'};
                } else if (customer.phone) {
                    return {field: 'byLastName', description: 'Last name'};
                }
            case 'byEmail':
                if (customer.phone) {
                    return {field: 'byPhone', description: 'Phone number'};
                } else {
                    return {field: 'byLastName', description: 'Last name'};
                }
            case 'byVin':
                return {field: 'byPhone', description: 'Phone number'};
            case 'byRefNumber':
                return {field: 'byPhone', description: 'Phone number'};
        }
    };

    //close verification panel in this case means go back on
    //previous stage
    $scope.closeVerificationPanel = function () {
        $scope.selectedVehicle = undefined;
        $scope.selectedCustomer = undefined;
        $scope.verificationFailed = false;
        $scope.verificationEmail = undefined;
    };

    //go to new customer page
    $scope.newCustomer = function () {
        $scope.searchResultLoader.addPromise(
            dealerModelService.checkAvailableTime().then(function (hasSlot) {
                if (hasSlot) {
                    resetModels();
                    $state.go('createcustomer.manufacturer');
                } else {
                    $scope.showNoTimeSlot = !hasSlot;
                }
            }).catch(function (err) {
                $log.error('Something went wrong due to get available time segment', err);
            }));
    };

    //customer wants to create new vehicle
    $scope.addNewVehicle = function (customer, index) {
        resetModels();
        customerModelService.setExistingAppointments(customer.appointments);
        customerModelService.setCustomer(customer);
        $scope.openVerificationPanel(undefined, customer, index);
    };

    function proceedVehicle(vehiclePreview) {
        // in this step customer is able to do just a 2 things
        // the first one is to create new vehicle
        // and the last one is to proceed with existing vehicle
        // if customer did not select any from offered vehicles
        // considering this case as creation of new vehicle
        // otherwice head customer to the check vehicle health page
        var rVehicle;
        if (vehiclePreview) {
            $scope.verificationLoader.addPromise(
                vehiclePreview.getVehicle().then(function (resolvedVehicle) {
                    rVehicle = resolvedVehicle;
                    customerModelService.setCurrentVehicle(VehicleService.extend(resolvedVehicle));
                    //TODO need vehicle comparsion
                    customerModelService.setRecallsUpdates();
                    return resolvedVehicle.make.getManufacturer();
                }).then(function (resolvedManufacture) {
                    customerModelService.getCurrentVehicle().setManufacturer(resolvedManufacture);
                    return rVehicle.getAppointments();
                }).then(function (apptPreviews) {
                    //filter all future appointments and missed appointments
                    //if they were within the same day
                    var currentDay = moment().startOf('day');
                    var filtered = _.filter(apptPreviews.appointments, function (appt) {
                        return moment(appt.scheduledTime).startOf('day') >= currentDay;
                    });
                    var sorted = _.orderBy(filtered, function (o) { return moment(o.scheduledTime) }, 'asc');
                    customerModelService.setExistingAppointments(sorted);
                })
                    .catch(function (err) {
                        $log.error('Something went wrong due to appointments acquiring');
                    })
                    .finally(function () {
                        // check if current vehicle doesn't have VIN Number on 'checkhealth' state instantly
                        // redirect to 'summary' state.
                        // Bug #14216
                        if (customerModelService.getCurrentVehicle().getVinNumber()) {
                            $state.go('checkhealth');
                        } else {
                            $state.go('checkhealth', {skip: true});
                        }
                    }));
        } else {
            //$scope.newCustomer();
            $state.go('createcustomer.manufacturer');
        }
    }

    //verify customer
    $scope.verifyCustomer = function (verificationValue, form) {

        if (!form.$valid) {
            form.verifyField.$setDirty();
            return;
        } else {
            form.verifyField.$setPristine();
            //form.$setPristine();
        }

        if ($scope.currentVerificationField === 'byPhone') {
            verificationValue = verificationValue.replace(/\D/g, '');
        }

        var verifyParams = {
            findValue: customerModelService.getSearchParameter(),
            foundType: $scope.selectedCustomer.foundType,
            verifyValue: verificationValue,
            verifyType: $scope.currentVerificationField
        };

        $scope.verificationLoader.addPromise(
            $scope.selectedCustomer.verify(verifyParams)
                .then(function (result) {
                    $scope.verificationFailed = !result.isValid;
                    var customer = result.customer;
                    if (customer) {
                        customer.existingCustomer = true;
                        customerModelService.setCustomer(customer, true);
                        proceedVehicle($scope.selectedVehicle);
                        sdAnalyticsService.sendScheduleServiceLogin();
                    } else {
                        return $q.reject('Customer property does not exist in API response.');
                    }
                })
                .catch(function (err) {
                    $log.error('Something went wrong due to customer verification process.', err);
                }));
    };

    var firstTimeShowSearch = true;
    var resolveCustomerTS;

    // resolve customer from server side
    function resolveCustomer(searchString) {
        errorScreenService.error(false, ERR.SEARCH_ERROR);
        resolveCustomerTS = new Date().getTime();

        return $scope.searchResultLoader.addPromise(
            customerModelService.searchCustomer($scope.searchString)
                .then(function (result) {
                    $scope.customers = result;

                    if (!$scope.customers.length) {
                        $scope.searchErrorOptions.errorContext = 'NOT_FOUND';
                        invokeSearchError();
                    } else if ($scope.customers.length) {

                        return $q.all($scope.customers.map(function (customer) {
                            // #10789 OS - VIN Search - Matched Customer Get Vehicles by GetByVIN API - Eliminate calls to get additional matched Vehicles of the Customer
                            var resolveVehicles;
                            if (customer.foundType === 'byVin') resolveVehicles = $q.resolve([customer.vehicle]);
                            else resolveVehicles = customer.getVehicles();
                            return resolveVehicles.then(function (vehicles) {
                                return $q.all(vehicles.map(function (v) {

                                    var vHref = _.get(_.find(v.links, {rel: "http://api.dealer-fx.com/docs/rels/vehicle"}), 'href');
                                    var customerVehicle = customer.vehicles.find(function (e) {
                                        return vHref && vHref === _.get(_.find(_.get(e, 'links'), {rel: "http://api.dealer-fx.com/docs/rels/vehicle"}), 'href');
                                    });

                                    var errId = errorRouterService.subscribe(function () {
                                        return $q.when(true);
                                    }, {resourceName: 'decodeVin', status: '500'});

                                    return v.getVehicle()
                                        .then(function (vehicle) {
                                            if (vehicle.vin) {
                                                customer.vinful = !!vehicle.vin;
                                            }
                                            if (customerVehicle) customerVehicle.ignore = false;
                                        })
                                        .catch(function (err) {
                                            console.error(err);
                                            if (customerVehicle) customerVehicle.ignore = true;
                                        })
                                        .finally(function () {
                                            errorRouterService.unsubscribe(errId);
                                        });
                                }))
                            }).catch(function (err) {
                                console.error(err);
                            })
                        }));
                    }
                })
                .catch(function (err) {
                    $scope.customers = [];
                    $scope.searchErrorOptions.errorContext = 'REQUEST_ERROR';
                    invokeSearchError();
                })
                .finally(function () {
                }), {minShowTime: (firstTimeShowSearch) ? 2000 : 10})

    }

    //Invoke search error screens with timeout for animation purposes;
    function invokeSearchError() {
        var s = 10;
        if (firstTimeShowSearch) {
            s = Math.max(10, 2000 - (new Date().getTime() - resolveCustomerTS) / 1000);
            firstTimeShowSearch = false;
        }

        $timeout(function () {
            errorScreenService.error(true, ERR.SEARCH_ERROR);
        }, s);
    }

    function onErrorContinueAsNewCustomer() {
        errorScreenService.error(false, ERR.SEARCH_ERROR);
        $state.go('createcustomer.manufacturer');
    }

    function resetModels() {
        customerModelService.resetModel();
        dealerModelService.resetModel();
        maintenanceModelService.resetModel();
        customerModelService.setSearchParameter($scope.searchString);
    }

    //check if we already have found customer in model
    var foundCustomers = customerModelService.getFoundCustomers();
    if (foundCustomers && foundCustomers.length) {
        $scope.customers = foundCustomers;
        $scope.openVerificationPanel(foundCustomers[0].vehicles[0], foundCustomers[0]);
    } else {
        resolveCustomer(customerModelService.getSearchParameter());
    }

    var noTimeSlotlListener = $scope.$on('bootstrapVin:showNoTimeSlot', function () {
        $scope.showNoTimeSlot = true;
    });

    var errorListener = errorScreenService.subscribe(function (show, errorId) {
        if (errorId === ERR.SEARCH_ERROR) {
            $scope.tryAgainButton = show;
        }
    });

    $scope.$on('$destroy', function () {
        noTimeSlotlListener();
        errorScreenService.unsubscribe(errorListener);
    });

    function offset(elm) {
        try {
            return elm.offset();
        } catch (e) {
        }
        var rawDom = (elm[0]) ? elm[0] : elm;
        var body = document.documentElement || document.body;
        var scrollX = window.pageXOffset || body.scrollLeft;
        var scrollY = window.pageYOffset || body.scrollTop;
        var _x = rawDom.getBoundingClientRect().left + scrollX;
        var _y = rawDom.getBoundingClientRect().top + scrollY;
        return {left: _x, top: _y};
    }

    init();
}

module.exports = SearchResultsCtrl;
